export enum ArmyListSize {
  Warbands = 0,
  Standard = 1,
  GrandArmies = 2,
}
